module.exports = __webpack_public_path__ + "static/media/Page2.4b6212ea.png";